export default {
  // 页面标题和描述
  appCenterTitle: '应用中心',
  appCenterDescription: '探索丰富的应用生态，提升您的工作效率',
  searchPlaceholder: '搜索应用名称或描述...',

  // 分类
  categoryAll: '全部',
  categoryAiInnovation: 'AI创新场',
  categoryAiInnovationDesc: 'AI驱动的创新解决方案',
  categoryCustoms: '海关专区',
  categoryCustomsDesc: '海关业务专业解决方案',
  categorySmartLogistics: '智慧物流系统',
  categorySmartLogisticsDesc: '智能高效的物流管理系统',
  categoryBrokerAgent: '经纪代理',
  categoryBrokerAgentDesc: '专业的经纪代理服务',
  categoryBookingPortal: '订舱门户',
  categoryBookingPortalDesc: '高效便捷的订舱服务平台',
  categoryToolbox: '工具箱',
  categoryToolboxDesc: '多样化的实用工具集合',

  // 子分类
  subcategoryUsCanada: '美加专区',
  subcategoryEu: '欧盟业务',
  subcategoryChina: '中国业务',
  subcategoryOther: '其他',
  subcategoryPortal: '定制门户',
  subcategoryCollaboration: '协作云平台',
  subcategoryUs: '美国业务',
  subcategoryCarrier: '船东',
  subcategoryAgent: '代理',
  subcategoryVisualization: '可视化',
  subcategoryTools: '实用助手',

  // 应用状态
  statusNotActivated: '未开通',
  statusPending: '审核中',
  statusApproved: '审核通过',
  statusRejected: '审核拒绝',
  statusDisabled: '禁用',

  // 按钮文本
  btnEnterApp: '进入应用',
  btnApplyAccess: '申请开通',
  btnPending: '审核中',
  btnRejected: '已拒绝',
  btnDisabled: '已禁用',

  // 弹窗相关
  modalAgreementTitle: '申请开通',
  modalAgreementDescription: '此应用需签订协议后使用，请上传加盖公章的协议文本等待审核开通。',
  modalRejectionTitle: '审核结果',
  modalRejectionReasonTitle: '拒绝原因',
  modalRejectionDescription: '请根据拒绝原因修改相关材料后重新上传，我们将重新进行审核。',
  modalUploadAreaTitle: '点击或拖拽文件到此区域上传',
  modalUploadAreaSubtitle: '支持 PDF、JPG、PNG 格式，大小不超过 10M',
  modalDownloadPrefix: '如您没有协议文件，请',
  modalDownloadLink: '下载模板',
  modalBtnCancel: '取消',
  modalBtnConfirmUpload: '确认上传',
  modalBtnReupload: '重新上传',
  modalBtnClose: '关闭',
  modalUploadSuccess: '上传成功',
  modalReuploadSuccess: '重新上传成功，请等待审核',
  modalDownloadTemplateMsg: '协议模板下载中...',
  modalSelectFileFirst: '请先选择文件上传',

  // 申请相关提示
  applySuccessMessage: '申请成功，等待审核',
  applyFailedMessage: '申请失败，请重试',

  // 加载状态
  loading: '加载中...',

  // 错误信息
  errorLoadFailed: '加载失败',
  errorActionFailed: '操作失败',
  errorUploadFailed: '上传失败',

  // 授权用户弹窗（CCTOWER-2652）
  authUser: '授权用户',
  authUserTitle: '授权用户',
  authCurrentApp: '当前应用',
  authAddPlaceholder: '输入员工用户名/姓名/邮箱/手机号，点搜索图标检索或直接添加',
  authAddBtn: '添加',
  authListTitle: '已授权用户（{count} / 最多 {max} 个）',
  authListEmpty: '暂无授权用户',
  authRoleAdmin: '管理员',
  authRoleMember: '成员',
  authRemove: '移除',
  authLoadFailed: '加载授权用户失败',
  authKeywordEmpty: '请输入员工用户名/姓名/邮箱/手机号',
  authDuplicate: '该用户已在授权列表中',
  authLimitReached: '已达授权上限（{limit} 个）',
  authUserNotFound: '未找到匹配的租户用户，请输入完整的用户名/姓名/邮箱/手机号',
  authAddFailed: '添加失败，请重试',
  authSearchFailed: '检索员工失败，请重试',
  authSearchEmpty: '未检索到匹配的员工',
  authAddSuccess: '添加成功',
  authRemoveSuccess: '移除成功',
  authRemoveFailed: '移除失败，请重试',
  authRemoveConfirmTitle: '移除授权用户',
  authRemoveConfirmContent: '确定将「{name}」移出该应用的授权名单吗？'
}
